import * as React from 'react';
import Tooltip from '@mui/material/Tooltip';
//import IconButton from '@mui/material/IconButton';
import HomeIcon from '@mui/icons-material/Home';
import { useDispatch } from 'react-redux';
import { getSearchByCoordinates, setCenter as setSearchCenter } from "../../features/searchSlice";
import Button from '@mui/material/Button';
import {  setCenter, setPublicPinClicked } from "../../features/dataProcessingSlice"
import { activateMarker } from '../../features/activeMarkers';
import PlaceIcon from '@mui/icons-material/Place';
import { useIsMobile } from '../../app/IsMobileContext';
import { setActivePinModal } from '../../features/utilitySlice';
import { useAuthProfile } from '../../app/hooks';
import { GetUserTypePinPNG } from '../markers/MMMarkers';
import { triggerUserMarkerClick } from '../markers/UserMarker';

export const CenterMapHome: React.FC<{ profileLat: number, profileLng: number, id: number }> = ({ profileLat, profileLng, id }) => {

  const dispatch = useDispatch<any>();
  const isMobile = useIsMobile();
  const { profile } = useAuthProfile();

  const handleHomeClick = () => {
    // Keep Redux in sync (but the real centering is done by map.panTo
    // inside triggerUserMarkerClick — avoids getSearchByCoordinates
    // whose fulfilled handler applies a latOffset that fights the pan)
    dispatch(setSearchCenter({ lat: profileLat, lng: profileLng }))

    // Pan the map + replay DROP → BOUNCE → InfoWindow animation
    if (triggerUserMarkerClick) {
      triggerUserMarkerClick()
    }
  }

  return (
    
        <Button 
          disableElevation
          variant="contained" 
          sx={{
            maxWidth: '40px', 
            maxHeight: '40px', 
            minWidth: '40px', 
            minHeight: '40px', 
            backgroundColor: 'rgba(244, 240, 255, 0.55)',
            backdropFilter: 'blur(24px)',
            WebkitBackdropFilter: 'blur(24px)',
            border: '1px solid rgba(164, 142, 233, 0.18)',
            boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
            '&:hover': { backgroundColor: 'rgba(244, 240, 255, 0.7)' },
          }} 
          onClick={handleHomeClick}
        > 
          <PlaceIcon sx={{color:'#656EFF'}} />
        </Button>
  );
}
